var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-8 mb-4",staticStyle:{"width":"816px","height":"1056px"},attrs:{"elevation":"5"}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }